import { PlainButton } from "@jugl-web/ui-components";
import { cx } from "@jugl-web/utils";
import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";

interface HeaderIconButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  label?: ReactNode;
  isActive?: boolean;
}

export const HeaderIconButton = forwardRef<
  HTMLButtonElement,
  HeaderIconButtonProps
>(({ icon, label, isActive, className, ...restProps }, ref) => (
  <PlainButton
    className={cx(
      "flex h-8 shrink-0 items-center rounded-lg border border-solid border-grey-300 bg-white outline outline-transparent transition outline-solid",
      label ? "gap-2 px-2" : "w-8 justify-center",
      isActive ? "outline-grey-300" : "hover:outline-grey-300",
      className
    )}
    {...restProps}
    ref={ref}
  >
    {icon}
    {label ? (
      <span className="truncate text-sm leading-[140%] font-normal text-[#1A2023]">
        {label}
      </span>
    ) : null}
  </PlainButton>
));

HeaderIconButton.displayName = "HeaderIconButton";
